export default class AttendanceSummaryModel {
  totalCount!: number;

  totalValue!: number;

  countByOrigin!: Record<string, number>;
}
